import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Authenticate } from '../models/auth/authenticate';
import { Token } from '../models/auth/token';
import { Organization } from '../models/organization';
import { View } from '../models/view';
import { SessionTimeoutService } from './session-timeout.service';
import { WebBrowserTabBlinkerService } from './web-browser-tab-blinker-service';

@Injectable({
    providedIn: 'root',
})
export class MemoryService {
    /**
     * L'organisation Selectionnée.
     */
    private selectedOrganizationChange: BehaviorSubject<Organization>;

    /**
     * L'utilisateur connecté.
     */
    public connectedUserChange: BehaviorSubject<Authenticate>;

    // get selectedOrganizationChange$() {
    //     return this.selectedOrganizationChange.asObservable();
    // }

    /**
     * La vue Selectionnée.
     */
    private selectedViewChange: BehaviorSubject<View>;

    get selectedViewChange$() {
        return this.selectedViewChange.asObservable();
    }

    /**
     * Emis lorsque l'utilisateur connecté change.
     */
    connectedUserChangeEvent: EventEmitter<Authenticate> = new EventEmitter<Authenticate>();

    /**
     * Emis lorsque l'organisation sélectionnée change.
     */
    organizationChangeEvent: EventEmitter<Organization> = new EventEmitter<Organization>();

    constructor(
        private timeoutService: SessionTimeoutService,
        private webBrowserTabBlinkerService: WebBrowserTabBlinkerService
    ) {
        let localSessionUser = Authenticate.from(JSON.parse(sessionStorage.getItem('user')));
        this.connectedUserChange = new BehaviorSubject<Authenticate>(localSessionUser);
        let localSessionOrganization = Organization.from(JSON.parse(sessionStorage.getItem('organization')));
        this.selectedOrganizationChange = new BehaviorSubject<Organization>(localSessionOrganization);
        this.selectedViewChange = new BehaviorSubject<View>(null);
    }
    /**
     * Retourne l'utilisateur connecté.
     * @returns : L'utilisateur connecté.
     */
    public getConnectedUser(): Authenticate {
        return this.connectedUserChange.value;
    }

    /**
     * Modifie l'utilisateur connecté.
     */
    public setConnectedUser(authenticate: Authenticate) {
        sessionStorage.setItem('user', JSON.stringify(authenticate));
        this.connectedUserChange.next(authenticate);
        this.connectedUserChangeEvent.emit(authenticate);

        if (authenticate) {
            this.timeoutService.startTimer(authenticate.token.expireOn);
        } else {
            this.timeoutService.stopTimer();
        }

        // Dans le cas où une notification d'expiration de session s'est affichée, arrête le clignotement de l'onglet si la session a expirée.
        this.webBrowserTabBlinkerService.stop();
    }

    public updateUserToken(token: any) {
        console.log("met à jour le token de l'utilisateur connecté");

        let connectedUser = this.getConnectedUser();
        connectedUser.token = new Token();
        connectedUser.token.accessToken = token.accessToken;
        connectedUser.token.expireOn = new Date(token.expireOn);

        sessionStorage.setItem('user', JSON.stringify(connectedUser));
    }

    /**
     * Indique si une organisation est selectionnée.
     * @returns : True si une organisation est selectionnée; false autrement.
     */
    public isOrganizationSelected(): boolean {
        return !!this.selectedOrganizationChange.value;
    }

    /**
     * Retourne l'organisation Selectionnée.
     * @returns L'organisation sélectionnée.
     */
    public getSelectedOrganization(): Organization {
        return this.selectedOrganizationChange.value;
    }

    /**
     * Modifie l'organisation selectionnée.
     */
    public selectOrganization(organization: Organization) {
        console.log('select organisation : ', organization);
        sessionStorage.setItem('organization', JSON.stringify(organization));
        this.selectedOrganizationChange.next(organization);
        this.organizationChangeEvent.emit(organization);
    }

    /**
     * Modifie la vue selectionnée.
     */
    public selectView(view: View) {
        console.log('select view : ', view);
        sessionStorage.setItem('view', JSON.stringify(view));
        this.selectedViewChange.next(view);
        //this.organizationChangeEvent.emit(view);
    }

    /**
     * Retourne la vue Selectionnée.
     * @returns La vue sélectionnée.
     */
    public getSelectedView(): View {
        return this.selectedViewChange.value;
    }

    /**
     * Indique si une vue est selectionnée.
     * @returns : True si une vue est selectionnée; false autrement.
     */
    public isViewSelected(): boolean {
        return !!this.selectedViewChange.value;
    }
}
